// Ponte para o Toast do PrimeReact, com a mesma interface do react-toastify que o
// mapa usava antes (toast.success/info/warn/error). O MapboxMap registra o ref do
// <Toast/> na montagem; qualquer componente do mapa importa `toast` daqui.
let toastRef = null;

export const registerToast = (ref) => {
    toastRef = ref;
};

const show = (severity, summary) => (detail) => {
    toastRef?.current?.show({ severity, summary, detail: String(detail), life: 3500 });
};

export const toast = {
    success: show('success', 'Sucesso'),
    info: show('info', 'Informação'),
    warn: show('warn', 'Atenção'),
    error: show('error', 'Erro'),
};
